import { render, staticRenderFns } from "./StoreHeader.vue?vue&type=template&id=5f556b4c&scoped=true&"
import script from "./StoreHeader.vue?vue&type=script&lang=js&"
export * from "./StoreHeader.vue?vue&type=script&lang=js&"
import style0 from "./StoreHeader.vue?vue&type=style&index=0&id=5f556b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f556b4c",
  null
  
)

export default component.exports